mainApp.directive('singleIpsRule', function() {
    return {
        templateUrl: '/public/directives/singleIpsRule.html',
        scope: {
            item: '=',
            tableConfig: '<'
        }
    }
});